import { apiClient } from "@wtf/shared/api/utils/api-client";
import { SubmitFeedbackRequest, SubmitFeedbackResponse } from "@wtf/shared";

const BASE_FEEDBACK = "api/feedback";

/**
 * Submit feedback to the backend
 */
export async function submitFeedback(data: SubmitFeedbackRequest): Promise<SubmitFeedbackResponse> {
  return apiClient<SubmitFeedbackResponse>(`${BASE_FEEDBACK}`, "POST", data);
}

export const feedbackApi = {
  submitFeedback,
};
